export default process.env.NODE_ENV === 'production' ? 'https://iss.verdedata.ro' : 'http://localhost:3400'
